var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDashed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 88,
    viewBox: "0 0 35 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 17",
    x1: 2,
    y1: -2,
    x2: 52.8507,
    y2: -2,
    transform: "matrix(-0.580466 0.814285 -0.808034 -0.589136 31.8389 0)",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 18",
    x1: 2,
    y1: -2,
    x2: 52.8507,
    y2: -2,
    transform: "matrix(-0.580466 -0.814285 -0.808034 0.589136 32 88)",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "11 11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDashed);
export default __webpack_public_path__ + "static/media/arrow_left_dashed.26d4a9f8727aa46bedc08f2db65d6d30.svg";
export { ForwardRef as ReactComponent };